<template>    
    <div class="banner-top-2 px-mob" v-if="enableDiscount">
        <rangeSlider></rangeSlider>
    </div>
    <div class="table-meal-plan flex-column pt-6 pb-8 px-mob px-md-6 d-flex justify-center">
        <div>
            <h2 class="mb-3 text-center">Weekly meal plan review</h2>
        </div>
        <div class="table-wrap">        
            <ul class="d-flex justify-center">
                <li class="mx-3 pb-2" v-for="(plan, i) in weeklyPlan" :key="i" @click="setClassActiveDay(i)" :class="[plan.view ? 'active' : '']" >{{ plan.title.substring(0, 3) }}</li>
            </ul>
        </div>
    </div>
    <div class="table-meal-plan border-bottom-none flex-column pt-6 pb-8 px-mob px-md-6 d-flex justify-center">
        <div>
            <h2 class="mb-3 text-center">Your personal weekly meal plan?</h2>
        </div>
        <div class="table-wrap">        
            <div class="table-title d-flex justify-center align-center">
                Your average daily calories <span class="icon-kcal">&#160; {{ orderSummary.kcals }} kcal</span>
            </div>
            <div class="table-data d-flex align-center">
                <div class="v-col-4" :class="{ 'low': orderSummary.proteins < minMaxValue.minProteins, 'high': orderSummary.proteins > minMaxValue.maxProteins }">Protein <span>{{ orderSummary.proteins }}g</span></div>
                <div class="v-col-4" :class="{ 'low': orderSummary.carbs < minMaxValue.minCarbs, 'high': orderSummary.carbs > minMaxValue.maxCarbs }"> Carbs <span>{{ minMaxValue.carbsText }}</span></div>
                <div class="v-col-4" :class="{ 'low': orderSummary.fats < minMaxValue.minFats , 'high': orderSummary.fats > minMaxValue.maxFats }"> Healthy fats <span>{{ minMaxValue.fatsText }}</span></div>
            </div>
            <div class="table-price d-flex justify-center align-center">
                <span>€ {{ orderSummary.price }}</span>/ per day
            </div>      
        </div>
    </div>
    <div class="block-summary d-flex justify-center py-6 px-mob">         
        <span v-for="(plan, i) in weeklyPlan" :key="i">
            <template v-if="plan.view == true">
                <strong class="pr-4">{{ plan.str }} summary:</strong>     
                {{ countMainMeals ? plan.countMain : 0 }} main meals, 
                {{ countBreakfast ? plan.countBreakfast : 0 }} breakfasts,            
                {{ countSnacks ? plan.countSnack : 0 }} snack
            </template>
        </span>
    </div>
    <alertApp />
    <div class="main-meals my-6 pb-2 px-mob" v-if="menus[1].count > 0">
        <div class="main-meals-wrap">
            <div v-for="(plan, i) in weeklyPlan" :key="i" :plan="plan">
                <h2 v-if="plan.view == true"> 
                    Main meals ({{ plan.countMain }})
                </h2>
            </div>
            <cardWizard 
                :products="setMainProducts" 
                category="main" 
                :weeklyPlan="weeklyPlan" 
                @close-popup-to-parent="showPopup = false"
                @open-popup-to-parent="showPopup = true"
            />           
        </div>
    </div>
    <div class="bg-color">
        <div class="main-meals my-6 py-7 px-mob" v-if="menus[0].count > 0">
            <div class="main-meals-wrap">
                <div v-for="(plan, i) in weeklyPlan" :key="i" :plan="plan">
                    <h2 v-if="plan.view == true">
                        Breakfast ({{ plan.countBreakfast }})
                    </h2>
                </div>
                 <cardWizard 
                    :products="setBreakfastProducts" 
                    category="breakfast" 
                    :weeklyPlan="weeklyPlan"
                    @close-popup-to-parent="showPopup = false"
                    @open-popup-to-parent="showPopup = true"
                 />                
            </div>
        </div>
    </div>
    <div class="main-meals pb-8 pt-6 px-mob bg-white" v-if="menus[2].count > 0">
        <div class="main-meals-wrap">
            <div v-for="(plan, i) in weeklyPlan" :key="i" :plan="plan">
                <h2 v-if="plan.view == true">
                    Snacks ({{ plan.countSnack }})
                </h2>
            </div>
            <cardWizard 
                :products="setSnacksProducts" 
                category="snacks" 
                :weeklyPlan="weeklyPlan"
                @close-popup-to-parent="showPopup = false"
                @open-popup-to-parent="showPopup = true" 
            />
        </div>
    </div>
    <div class="block-price-total">
        <div class="block-price-total-wrap">
            <div class="d-flex justify-center btn-view-order" @click=" viewOrder = ! viewOrder ">
                <div class="icon-btn-order" :class="[viewOrder ? 'open' : '']">       
                    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="14.0005" cy="14" r="11.48" transform="rotate(-180 14.0005 14)" fill="#2AD2C9"/>
                        <path d="M8.98079 1.16502C10.574 0.719819 12.2456 0.547618 13.892 0.304018C16.3588 -0.0613822 18.3384 1.13142 20.5322 2.02882C22.5258 2.84502 23.5828 4.31922 24.9632 5.60722C24.8778 5.57082 24.7966 5.54422 24.714 5.51622C24.7952 5.54142 24.8778 5.56662 24.959 5.59182C26.4654 7.24522 27.0702 9.32422 27.5336 11.4172C28.116 14.0562 28.431 16.7288 26.751 19.1564C26.6628 19.2838 26.2106 20.6334 25.8998 21.101C24.3444 23.4446 22.4152 25.3122 19.7146 26.4504C17.1428 27.534 14.5528 28.1528 11.8368 27.7216C10.07 27.4416 8.22479 27.226 6.80239 25.7574C5.73979 24.6612 4.21239 24.0074 3.18339 22.8888C0.198587 19.6478 -0.337613 15.6858 0.169187 11.4648C0.447787 8.59622 2.86139 5.44622 3.62859 4.40462C4.75839 2.87162 8.26679 1.26022 8.98219 1.16502H8.98079ZM10.7854 24.1782L10.7812 24.139C12.4318 24.2902 14.0838 24.5744 15.733 24.5632C18.7906 24.5436 20.8192 22.6984 22.4782 20.3604C24.567 17.4134 25.1564 14.136 23.986 10.7536C22.9976 7.89342 21.1314 5.61842 18.2516 4.32342C17.7868 4.11482 15.7834 3.57862 15.1282 3.43582C13.08 2.98642 11.2138 3.50862 9.37699 4.26042C6.54759 5.41822 4.96699 7.76882 3.66219 10.3714C3.38359 10.9286 3.07139 14.549 3.33459 15.8188C3.54599 16.8436 3.87219 17.8446 4.15359 18.8484C4.16479 18.8638 4.17599 18.8778 4.18719 18.8932C4.18579 18.8666 4.18299 18.84 4.18159 18.8134C4.60719 19.4658 4.89559 20.3086 5.48499 20.737C7.18739 21.9732 9.01159 23.0428 10.7868 24.1768L10.7854 24.1782ZM19.8434 23.4474L19.7874 23.5398L19.8812 23.5482L19.8434 23.4474Z" fill="#2AD2C9"/>
                        <path d="M16.4669 12.987C16.4669 12.987 16.409 13.0946 16.409 13.0996C17.7496 12.037 19.0709 10.9433 20.4469 9.92356C20.782 9.67492 21.3137 9.54724 21.7262 9.59848C21.9916 9.63124 22.4377 10.131 22.399 10.3511C22.2789 11.0391 22.1285 11.8278 21.7035 12.3394C19.6825 14.7695 17.6194 17.1694 15.4682 19.4836C13.9763 21.0888 12.4181 20.9553 11.0666 19.2114C9.49157 17.1803 7.96949 15.1072 6.46169 13.0248C5.39741 11.5548 5.32601 10.1789 6.20717 9.64972C7.30421 8.99116 8.63981 9.50776 9.60413 10.9954C10.3349 12.1218 13.2002 16.2798 13.2993 16.2462C14.3375 15.1845 15.3749 14.1227 16.4132 13.061L16.4653 12.9879L16.4669 12.987Z" fill="#1D2433"/>
                    </svg>
                </div>         
            </div>
            <div class="banner-bottom">
                <div class="banner-bottom-row px-mob">
                    <h4>Weekly plan cost per day</h4>
                    <p>€ {{ orderSummary.price }} </p>
                </div>
            </div>
        </div>
    </div>   
    <transition name="anim-order-data" tag="div">
        <div class="order-wrap" v-if="viewOrder">
            <div class="order-wrap-container px-mob"> 
                <ul class="v-list">
                    <li class="v-list-item-title"><span><strong>Plan:</strong></span> <span>{{ itemsOrder.plan.title }}</span></li>
                    <li class="v-list-item-title"><span><strong>Customise:</strong></span> <span>{{ viewCustomise ?? '-' }}</span></li>
                    <li class="v-list-item-title"><span><strong>Protein:</strong></span> <span>{{ itemsOrder.protein.title ?? '-' }}</span></li>
                    <li class="v-list-item-title"><span><strong>Days:</strong></span> <span>{{ itemsOrder.days }}</span></li>
                    <li class="v-list-item-title"><span><strong>Main Meals:</strong></span> <span>{{ countMainMeals }}</span></li>
                    <li class="v-list-item-title"><span><strong>Breakfasts:</strong></span> <span>{{ countBreakfast }}</span></li>
                    <li class="v-list-item-title"><span><strong>Snacks:</strong></span> <span>{{ countSnacks }}</span></li>
                    <li class="v-list-item-title"><span><strong>Summary:</strong></span> <span>{{ orderSummary.str }}</span></li>
                </ul>
                <div class="discount-row" v-if="enableDiscount && !editOrder">
                    <div class="banner-bottom-row px-mob">
                        <h4>Discount</h4>
                        <p>-€ {{ (discountSumm / 100).toFixed(2) }} ({{ itemsOrder.plan.discount }} %)</p>
                    </div>
                </div>
                <div class="total-row" v-if="!editOrder">
                    <div class="banner-bottom-row px-mob py-6">
                        <h4>Total</h4>
                        <p>€{{ ((getTotalOrder - discountSumm )/100).toFixed(2) }}</p>
                    </div>
                </div>
            </div>
        </div>
    </transition>
    <div class="d-flex justify-center py-6 px-mob wrap-btn">
        <button class="btn-main-app" :class="[btnDisabled ? 'disabled' : '']" @click="addToCart">Save and continue</button>              
    </div>
    <div class="row-progress-bar" v-if="showProgress">
        <v-progress-linear indeterminate color="#2ad2c9"></v-progress-linear>   
    </div>
    <mainPopup :visible="showPopup" @update:visible="closePopup">
        <div class="popup-wrap">
            <div class="popup-wrap-inside">
                <PopupProduct :showPopup="showPopup" @update:visible="closePopup" />
            </div>
        </div>
    </mainPopup>
</template>

<script>

import mainPopup from '@/components/common/mainPopup.vue';
import PopupProduct from '@/components/popupProduct.vue';
import { distributeProducts, getAllDishes, getActiveDay, getProductsInCard } from '@/helpers/helpFunctions';
import rangeSlider from '@/components/rangeSlider.vue';
import alertApp from '@/components/common/alertApp';
import cardWizard from '@/components/cards/cardWizard';
import { url } from '@/api/api.js';
import Cookies from 'js-cookie';

export default {
    name: 'step-6',
    components: {
        rangeSlider,
        cardWizard,
        alertApp,
        PopupProduct,
        mainPopup,
    },
    data() {
        return {
            showPopup: false,
            showProgress: false,
            viewOrder: false,
            proteinsPlan: 0,
            examinationProduct: [],
            editOrder: false
        }
    },
    computed: {
        menus() {       
            return this.$store.getters.getMenus;
        },
        enableDiscount() {
            return this.$store.getters.enableDiscount;
        },
        currentUserData() {
            return this.$store.getters.currentUserData;
        },
        weeklyPlan() {
            let plans = this.$store.getters.weeklyPlan;
            plans = plans.filter( plan => ( plan.active == true));
            return plans;
        },
        itemsOrder() {   
            return this.$store.getters.itemsOrder;
        },
        orderProducts() {            
            return this.$store.getters.orderProducts;
        },
        btnDisabled() {            
            if ( this.countMainMeals + this.countBreakfast + this.countSnacks ) {
                return false;                
            } else {               
                return true;                
            }
        },
        activeDay() {
            return getActiveDay( this.weeklyPlan );
        },
        setMainProducts() {   
            return getAllDishes(
                this.orderProducts.mainProducts,
                this.activeDay,
                this.menus[1].count
            );
        },
        setBreakfastProducts() {      
            return getAllDishes(
                this.orderProducts.breakfastProducts, 
                this.activeDay, 
                this.menus[0].count
            );

        },
        setSnacksProducts() {

            return getAllDishes(
                this.orderProducts.snacksProducts, 
                this.activeDay, 
                this.menus[2].count
            );
        },
        getAllMain() {
            return getProductsInCard(this.orderProducts.mainProducts, this.itemsOrder.days, this.menus[1].count);
        },
        getAllSnacks() {
            return getProductsInCard(this.orderProducts.snacksProducts, this.itemsOrder.days, this.menus[2].count);
        },
        getAllBreakfast() {
            return getProductsInCard(this.orderProducts.breakfastProducts, this.itemsOrder.days, this.menus[0].count);
        },
        allergies() {
            return this.$store.getters.getAllergies;
        },
        protein() {
            return this.$store.getters.proteinsType;
        },
        discount() {
            if ( this.enableDiscount ) {
                return this.$store.getters.discount;
            } else {
                return 0;
            }
        },
        getTotalOrder() {
            let sum = 0;

            if ( this.getAllBreakfast && this.getAllBreakfast.length > 0 ) {               
                this.getAllBreakfast.forEach(function(item) {
                    sum = sum + (item.price * item.count);
                });
            }

            if ( this.getAllMain && this.getAllMain.length > 0 ) {
                this.getAllMain.forEach(function (item) {
                    sum = sum + (item.price * item.count);
                });
            }

            if ( this.getAllSnacks && this.getAllSnacks.length > 0 ) {
                this.getAllSnacks.forEach( function( item ) {
                    sum = sum + ( item.price * item.count );
                } );
            }
                 
            return sum;
        },
        discountSumm() {
            if ( this.enableDiscount ) {
                return ( this.getTotalOrder * this.itemsOrder.discount )/100;
            } else {
                return 0;
            }
        },
        plans() {            
            return this.$store.getters.plansWeek;
        },
        mainProducts() {            
            return this.$store.getters.getMainProducts;
        },
        breakfastProducts() {
            return this.$store.getters.getBreakfastProducts;
        },
        snacksProducts() {
            return this.$store.getters.getSnacksProducts;
        },
        countMainMeals() {
            return this.itemsOrder.days * this.menus[1].count;
        },
        countBreakfast() {
            return this.itemsOrder.days * this.menus[0].count;                        
        },
        countSnacks() {
            return this.itemsOrder.days * this.menus[2].count;
        },
        viewCustomise() {
            
            if( this.itemsOrder.customise ) {
                return this.itemsOrder.customise;
            } else {
                return '-';
            }            
        },
        orderSummary() {
            let allOrderProducts = [...this.setSnacksProducts, ...this.setBreakfastProducts, ...this.setMainProducts];
            let kcals = 0;
            let proteins = 0;
            let carbs = 0;
            let fats = 0;
            let price = 0;

            allOrderProducts.forEach(function (item) {
                kcals += Number(item.kcals) * Number(item.count);
                proteins += Number(item.protein) * Number(item.count);
                carbs += Number(item.carbs) * Number(item.count);
                price += Number(item.price) * Number(item.count);
                if(Number(item.fats)) {
                    fats += Number(item.fats) * Number(item.count);
                }
            });

            let planActive = this.plansData.filter(plan => ( plan.isActive == true || plan.cat_prod_id == Cookies.get('plan') ));

            if(this.setSnacksProducts && this.setBreakfastProducts && this.setMainProducts && this.setMainProducts.length > 0) {
                this.setDataPopup(kcals, planActive[0].kcals);
            }
           
            this.setWarning();

            return {
                str: kcals + ' kcal, ' + proteins + ' g - Protein, ' + carbs + ' - Carbs, ' + fats + ' - Fats.',
                kcals: Math.round(kcals),
                proteins: Math.round(proteins),
                carbs: Math.round(carbs),
                fats: Math.round(fats),
                price: (Math.round(price)/100).toFixed(2),
            }

        },
        plansData() {
            return this.$store.getters.basicPlans;
        },
        minMaxValue() {
            let planActive = this.plansData.filter(plan => (plan.isActive == true || plan.cat_prod_id == Cookies.get('plan')));
            let fatsText = '';
            let carbsText = '';

            if ( planActive && planActive[0].fats_value_low && this.orderSummary.fats < planActive[0].fats_value_low ) {
                fatsText = 'low';
            } else if( planActive && this.orderSummary.fats > planActive[0].fats_value_high ) {
                fatsText = 'high';
            } else {
                fatsText = 'Medium';
            }
                       
            if ( this.orderSummary.carbs < planActive[0].cals_value_low ) {
                carbsText = 'low';
            } else if ( this.orderSummary.carbs > planActive[0].cals_value_hight ) {
                carbsText = 'high';
            } else {
                carbsText = 'Medium';
            }

            return {
                minFats: planActive[0].fats_value_low,
                maxFats: planActive[0].fats_value_high,
                fatsText: fatsText,
                minproteins: planActive[0].proteins_value_low,
                maxproteins: planActive[0].proteins_value_high,
                minCarbs: planActive[0].cals_value_low,
                maxCarbs: planActive[0].cals_value_hight,
                carbsText: carbsText
            };
        },
    },
    methods: {
        closePopup() {
            this.showPopup = false; // Закрытие попапа
        },
        setWarning() {
            setTimeout(() => {  
                if ( 
                    !( this.countMainMeals > 0 && this.setMainProducts.length > 0)
                    || !( this.countBreakfast > 0 && this.setBreakfastProducts.length > 0)
                    || !( this.countSnacks > 0 && this.setSnacksProducts.length > 0 )
                ) {
                    this.$store.commit('setAlertData', {
                        visible: true,
                        title: 'Warning',
                        text: 'There are currently not enough products that meet your criteria.',
                        type: 'warning'
                    });
                }   

            }, 5000);
        },
        setDataPopup( kcals, planActiveCals ) {

            if ( Number( kcals ) < Number( planActiveCals ) - 400 ) {
                setTimeout( () => {
                    this.$store.commit('setAlertData', {                        
                        title: 'Warning',
                        text: 'Reduced daily calorie intake by ' + (planActiveCals - kcals) + ' kcals',
                        type: 'warning',
                        visible: true,
                    });
                }, 3000);

            } else if (Number(kcals) > Number(planActiveCals) + 1000) {
                
                setTimeout(() => {
                    this.$store.commit('setAlertData', {
                        title: 'Warning',
                        text: 'Increasing your daily calorie intake by ' + (kcals - planActiveCals) + ' kcals',
                        type: 'error',
                        visible: true,
                    });
                }, 3000);

            } else {
                this.$store.commit('setAlertData', {
                    visible: false,
                    title: '',
                    text: '',
                    type: ''
                });
            }

        },
        addToCart() {  
            this.showProgress       = true;
            let days                = 1;
            let data                = [];
            let addProductID        = [];

            if ( this.getAllMain && this.getAllMain.length > 0 ) {
                this.getAllMain.forEach( ( product ) => {                

                    if ( addProductID.some( id => id == product.ID ) ) {

                        data.map( item => {
                            if( item.ID == product.ID ) {
                                item.count += product.count;
                            }
                        });
                       
                    } else {                        
                        let newProd = {
                            ID: product.ID,
                            count: product.count
                        }

                        data.push( newProd );
                        addProductID.push( product.ID );                     
                    }                 
                    
                } );
            }

            if ( this.getAllSnacks && this.getAllSnacks.length > 0 ) {
                this.getAllSnacks.forEach( ( product ) => {

                    if ( addProductID.some( id => id == product.ID ) ) {

                        data.map( item => {
                            if ( item.ID == product.ID ) {
                                item.count += product.count;
                            }
                        });
                       
                    } else {

                        let newProd = {
                            ID: product.ID,
                            count: product.count
                        }

                        data.push( newProd );
                        addProductID.push( product.ID );
                  
                    }

                });
            }

            if ( this.getAllBreakfast && this.getAllBreakfast.length > 0 ) {
                this.getAllBreakfast.forEach( ( product ) => {

                    if ( addProductID.some( id => id == product.ID ) ) {

                        data.map(item => {
                            if (item.ID == product.ID) {
                                item.count += product.count;
                            }
                        });
         
                    } else {

                        let newProd = {
                            ID: product.ID,
                            count: product.count
                        }

                        data.push(newProd);
                        addProductID.push(product.ID);
  
                    }

                });
            }

            let products = '';

            data.forEach(function (item ) {
                products += item.ID + ':' + (item.count) + ',';               
            });

            this.weeklyPlan.forEach(function (day, index) {
                if (day.active == true) {
                    days = index + 1;
                }
            });

            let form    = document.createElement("form");
            form.setAttribute('method', "post");
            form.setAttribute('action', url + '/checkout/');
            
            let plan = document.createElement("input");
            plan.setAttribute('type', "hidden");
            plan.setAttribute('name', "plan");
            plan.setAttribute('value', this.itemsOrder.plan.title);

            let daysF = document.createElement("input");
            daysF.setAttribute('type', "hidden");
            daysF.setAttribute('name', "days");
            daysF.setAttribute('value', days);

            let discountF = document.createElement("input");
            discountF.setAttribute('type', "hidden");
            discountF.setAttribute('name', "discount");

            if( this.enableDiscount ) {
                discountF.setAttribute('value', this.itemsOrder.discount);
            } else {
                discountF.setAttribute('value', 0);
            }

            let productsF = document.createElement("input");
            productsF.setAttribute('type', "hidden");
            productsF.setAttribute('name', "products");
            productsF.setAttribute('value', products.slice(0, -1) );

            let protein = document.createElement("input");
            protein.setAttribute('type', "hidden");
            protein.setAttribute('name', "protein");
            protein.setAttribute('value', this.itemsOrder.protein.title );
            
            let customise = document.createElement("input");
            customise.setAttribute('type', "hidden");
            customise.setAttribute('name', "customise");
            customise.setAttribute( 'value', this.viewCustomise );

            let summary = document.createElement("input");
            summary.setAttribute('type', "hidden");
            summary.setAttribute('name', "summary");
            summary.setAttribute('value', this.orderSummary.str );
            
            let main = document.createElement("input");
            main.setAttribute('type', "hidden");
            main.setAttribute('name', "main");
            main.setAttribute( 'value', this.countMainMeals );

            let snacks = document.createElement("input");
            snacks.setAttribute('type', "hidden");
            snacks.setAttribute('name', "snacks");
            snacks.setAttribute( 'value', this.countSnacks );

            let breakfast = document.createElement("input");
            breakfast.setAttribute('type', "hidden");
            breakfast.setAttribute('name', "breakfast");
            breakfast.setAttribute( 'value', this.countBreakfast );
           
            let mainDishData = distributeProducts(this.weeklyPlan, this.orderProducts.breakfastProducts, this.orderProducts.mainProducts, this.orderProducts.snacksProducts);
            let MDP = JSON.stringify(mainDishData, null, 2);
            let mainDataPlan    = document.createElement("input");
            mainDataPlan.setAttribute('type', "hidden");
            mainDataPlan.setAttribute('name', "main-data-plan");
            mainDataPlan.setAttribute( 'value', MDP );

            form.appendChild( plan );
            form.appendChild( daysF );
            form.appendChild( discountF );
            form.appendChild( productsF );
            form.appendChild( protein );
            form.appendChild( customise );
            form.appendChild( main );
            form.appendChild( snacks );
            form.appendChild( breakfast );
            form.appendChild( mainDataPlan );
            form.appendChild( summary );
            document.body.appendChild( form );            
            form.submit();
        
        },
        setClassActiveDay(i) {

            this.weeklyPlan.forEach((plan, index) => {
                plan.view = false;

                if ( index === i ) {
                    plan.view = true;
                }
            });

        },
    },
    async beforeMount() {
        
        const urlCurrent = new URL(window.location.href);
        const params = new URLSearchParams(urlCurrent.search);
        const order_id = params.get('order_id');

        if (order_id) {

            this.editOrder = true;
            
            Cookies.remove('plan');
            Cookies.remove('allergies');
            Cookies.remove('allergiesNo');
            Cookies.remove('protein');
            Cookies.remove('days');
            Cookies.remove('breakfastCount');
            Cookies.remove('mainCount');
            Cookies.remove('snacksCount');
        }

        if ( this.menus[0].count > 0 ) {
            this.$store.dispatch(
                'getProducts', 
                { 
                    mealType: 'breakfast',
                    count: this.menus[0].count * this.itemsOrder.days, 
                    allergies: this.allergies, 
                    plan: this.itemsOrder.plan.cat_prod_id, 
                    protein: this.itemsOrder.protein.slug 
                }
            );
        } 

        if ( this.menus[1].count > 0 ) {
            this.$store.dispatch(
                'getProducts', 
                {
                    mealType: 'mains',
                    count: this.menus[1].count  * this.itemsOrder.days, 
                    allergies: this.allergies, 
                    plan: this.itemsOrder.plan.cat_prod_id, 
                    protein: this.itemsOrder.protein.slug 
                });
        } 

        if ( this.menus[2].count > 0 ) {
            this.$store.dispatch(
                'getProducts', 
                { 
                    mealType: 'snacks',
                    count: this.menus[2].count * this.itemsOrder.days, 
                    allergies: this.allergies, 
                    plan: this.itemsOrder.plan.cat_prod_id, 
                    protein: this.itemsOrder.protein.slug 
                }
            );
        }   
        
        this.weeklyPlan.forEach(plan => {

            if ( plan.active == true ) {
                plan.countBreakfast = this.menus[0].count;
                plan.countMain      = this.menus[1].count;
                plan.countSnack     = this.menus[2].count;
            }

        });
    
    },
}

</script>

<style lang="stylus"> 
.icon-kcal {
    font-weight: 700;
}
  @keyframes slideOutUpAdd {
        from {
            height: 100%;
        }

        to {
            visibility: hidden;
            heigth: 0;
        }
    }

    .fade-enter,
    .fade-leave-to {
        opacity: 0;
        height: 0;
        z-index: -9999;
    }
    .anim-order-data-enter-active {
        animation: .3s slideInDown forwards;
    }
    .anim-order-data-leave-active {
        animation: .4s slideInUp forwards;
    }

    .total-row {
        .banner-bottom-row {
            border-top: 2px solid #E1E6EF;
        }

        h4 {
            font-family: 'Manrope', sans-serif;
            font-style: normal;
            font-weight: 800;
            font-size: 20px;
            line-height: 27px;
            color: #1D2433;
        }

        p {
            font-family: 'Manrope', sans-serif;
            font-style: normal;
            font-weight: 800;
            font-size: 24px;
            line-height: 33px;
            text-align: right;
            color: #685BC7;
        }
    }
    .order-wrap-container {
        max-width: 500px;
        margin: auto;
        overflow: hidden;
        width: 100%;
    }
    .order-wrap {
        display: flex;
        flex-direction: column;
        align-item: center;
        z-index: 0;
        background-color: #F8F9FC;
        overflow: hidden;
        transition-duration: .4s;
        
        .v-list {
            border-top: 2px solid #E1E6EF;
            max-width: 500px;
            margin: auto;
            background: none;
            padding-top: 1rem!important;
            padding-bottom: 1rem!important;
             
            .v-list-item {
                min-height: 0;
                height: auto;
                padding-top: 0;

                &:last-child {
                    padding-bottom: 0;
                }
            }

            .v-list-item-title {
                font-family: 'Manrope', sans-serif;
                font-style: normal;
                font-weight: 400;
                font-size: 16px;
                line-height: 1.3;
                color: #1D2433;
                padding-bottom: .5rem

                @media screen and (max-width: 767px) {
                    font-size: 14px;
                }

                @media screen and (max-width: 600px) {
                    display: flex;
                    flex-wrap: wrap;
                }
                
                span {
                    display: inline-flex;
                    flex-wrap: wrap;
                    &:first-child {
                        width: 95px;
                    }
                    &:last-child {
                        width: calc(100% - 105px);
                        line-height: 1.3;
                        white-space: normal;                        
                    }
                }
            }
        }
    }
    .wrap-btn 
        border-top: 2px solid #E1E6EF;
    .block-price-total {
        overflow: hidden;        
        position: relative;
        background: #fff;
        transition: all .2s;
        display: flex;
        justify-content: center;
        z-index: 10;

        &-wrap {
            border-width: 2px 0px 0;
            border-style: solid;
            border-color: #E1E6EF;
            background-color: #F8F9FC;
            display: flex;
            flex-direction: column;
            margin-top: 14px 
            width: 100%;
        }

        .btn-view-order {
            position: absolute;
            top: 0;
            left: calc(50% - 14px);
            cursor: pointer;
            z-index: 15;

            .icon-btn-order {
                transition-duration: .2s;
                transition-delay: .1s;
                &.open {
                    transform: translateY(-5px) rotate(180deg);                  
                }
            }
        }

    }

    .discount-row,
    .banner-bottom {
        background-image: url('/src/assets/images/banner-bottom.jpg');
        padding: 16px 0;      
        font-family: 'Manrope', sans-serif;
        font-style: normal;
        color: #1D2433;
        background-position: center 10%;
        background-position: center center;
        //background-repeat: repeat
        z-index: 10;
        background-color: #f8f9fc;
        display: flex;

        &-row {
            max-width: 500px;
            margin: auto;
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-wrap: wrap;
            width: 100%;
        }

        p {            
            font-weight: 800;
            font-size: 18px;
            line-height: 25px;            
        }

        h4 {
            font-weight: 700;
            font-size: 16px;
            line-height: 19px;

            @media screen and (max-width: 767px) {
                font-size: 14px;
            }
        }
    }
    .discount-row {
        background-image: none;
        border-top: 2px solid #E1E6EF;
    }
    .main-meals {
        width: 100%;        
        z-index: 100;
        display: flex;
        position: relative;
        z-index: 1;

        &-wrap {
            width: 100%;
            max-width: 500px;
            margin: auto;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            z-index: 10;
            
            h2 {
                font-size: 20px;

                @media (max-width: 767px) {
                    font-size: 18px;
                }
            }
        }
        &.bg-white {
            background-color: #fff;
        }

        &:before {
            background:inherit;
            width: 100%;
            height: 100%;
            content: '';
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            z-index: 0;
            display: flex;
        }
        .products-row {
            z-index: 15;
            width: 100%;
        }
    }

    .block-summary {
        font-family: 'Manrope', sans-serif;
        font-style: normal;
        font-weight: 800;
        font-size: 16px;
        line-height: 19px;
        color: #1D2433;
        border-top: 2px solid #e1e6ef;
        border-bottom: 2px solid #e1e6ef;
        background-color: #f8f9fc;

        @media screen and (max-width: 767px) {
            font-size: 14px;
        }

        span {
            color: #685BC7;
        }
    }
    .banner-top-2 {
        padding: 13px 0;
    }

    .table-wrap ul {
        list-style: none;

        li {
            font-family: 'Manrope', sans-serif;
            font-style: normal;
            font-weight: 800;
            font-size: 16px;
            line-height: 19px;
            display: flex;
            align-items: center;
            text-align: center;
            letter-spacing: -0.02em;
            color: #1d2433;
            border-bottom: 3px solid #1d2433;
            transition-duration: 0.4s;
            cursor: pointer
            
            @media screen and (max-width: 767px) {
                font-size: 14px;
            }

            &:hover,
            &.active {
                color: #685bc7;
                border-bottom: 3px solid #685bc7;
                transition-duration: 0.4s;
            }
        }
    } 
    
    .table-wrap {
        max-width: 550px;
        margin: auto;
        width: 100%;

        @media screen and (max-width: 767px) {
            max-width: 450px;
        }
        .table-title {
            color: #fff;
            background: #2E2858;
            border-radius: 10px 10px 0px 0px;
            height: 44px;
        }
        .table-data {
            height: 65px;
            background: #FFFFFF;
            border-right: 2px solid #E1E6EF;
            border-left: 2px solid #E1E6EF;  
            overflow: hidden;  
            text-transform: capitalize;

            @media screen and (max-width: 767px) {
                height: 47px;
            } 
            
            @media screen and (max-width: 350px) {
                height: 65px;
            } 

            div {
                border-right: 2px solid #E1E6EF;
                font-family: 'Manrope', sans-serif;
                font-style: normal;
                font-weight: 700;
                font-size: 16px;
                line-height: 1.5;
                color: #1D2433;
                display: flex;
                flex-direction: column;
                padding: 8px 0 8px 50px;
                position: relative;

                @media screen and (max-width: 767px) {
                    font-size: 12px;
                }

                @media screen and (max-width: 450px) {
                    padding: 8px 0 8px 30px;
                    line-height: 1.3;
                }

                &:before {
                   position: absolute;
                   content: '';
                   background: url('/src/assets/images/icons/protein.svg'); 
                   background-size: cover;
                   width: 20px;
                   height: 20px;
                   top: 8px;
                   left: 45px;

                    @media screen and (max-width: 767px) {
                        left: 38px;
                        top: 6px;
                        width: 15px;
                        height: 15px;
                    }
                    
                    @media screen and (max-width: 460px) {
                        left: 22%;
                    }
                    
                    @media screen and (max-width: 350px) {
                        top: 15px;
                    }
                }

                &:nth-child(2):before {
                    background: url('/src/assets/images/icons/carbs.svg');
                    width: 24px;
                    background-size: cover;
                    left: 41px;
                    height: 19px;

                    @media screen and (max-width: 767px) {
                        width: 19px;
                        left: 35px;
                        height: 15px;
                    }
                    
                    @media screen and (max-width: 460px) {
                        left: 18%;
                    }
                    
                    @media screen and (max-width: 350px) {
                        top: 15px;
                    }
                }
                
                &:nth-child(3):before {
                    background: url('/src/assets/images/icons/fats.svg');
                    background-size: cover;
                    left: 27px;
                    width: 15px;

                    @media screen and (max-width: 767px) {
                        width: 11px;
                        height: 15px;
                        left: 35px;
                    }

                    @media screen and (max-width: 460px) {
                        left: 10%;
                    }

                    @media screen and (max-width: 350px) {
                        top: 7px;
                    }
                }
                
                &:after {
                   position: absolute;
                   content: '';
                   background: url('/src/assets/images/icons/check-green.svg'); 
                   background-size: cover;
                   width: 14px;
                   height: 14px;
                   top: 37px;
                   left: 25px;

                    @media screen and (max-width: 767px) {
                            top: 27px;
                            left: 23%;
                    }
                    
                    @media screen and (max-width: 450px) {
                        left: 12px;
                        top: 24px;                      
                    }
                }
                
                &:first-child,
                &:nth-child(2)  {
                    padding: 8px 0 8px 13%;

                    @media screen and (max-width: 350px) {
                        height: 65px;
                        padding: 16px 0 8px 13%;
                    }

                    &:after {
                        left: 28%;

                        @media screen and (max-width: 550px) {
                            left: 25%;
                        }
                        @media screen and (max-width: 350px) {
                            top: 32px;
                            left: 20%;
                        }
                    }
                }

                span {
                    color: #2AD2C9;
                }

                &.low {
                   
                    &:after {
                        background: url(/src/assets/images/icons/alert.svg);     
                    }

                    span {                
                        font-weight: 800;
                        color: #FF8200;
                    }
                }
                &.high {

                    &:after {
                        background: url(/src/assets/images/icons/alert-high.svg);     
                    }

                    span {                
                        font-weight: 800;
                        color: red;
                    }
                }
                &:last-child {
                    border-right: none;
                }
            }
        }
        .table-price {
            height: 44px;
            background: #FFFFFF;
            border: 2px solid #E1E6EF;
            border-radius: 0px 0px 10px 10px;
            font-family: 'Manrope';
            font-style: normal;
            font-weight: 700;
            font-size: 16px;
            line-height: 19px;
            color: #1D2433;

            @media screen and (max-width: 767px) {
                font-size: 14px;
            }

            span {
                font-weight: 800;
                font-size: 24px;
                line-height: 33px;
                color: #685BC7;
                padding-right: 10px;
            }
        }
    }
    .table-meal-plan.border-bottom-none {
        border: none;
        background: none;
    }
    .row-progress-bar {
        overflow: hidden;
        max-width: 360px;
        margin: 1rem auto;
    }

</style>